// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fea026ae","436":"1a9cb3bf","453":"470c3363","676":"76a08f3d","788":"14bc6221"}[chunkId] + ".chunk.js";
};